import { ABP, eLayoutType } from '@abp/ng.core';

export const PAYMENT_REQUEST_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/payment-requests',
    iconClass: 'fas fa-money',
    name: '::Menu:PaymentRequests',
    layout: eLayoutType.application,
    requiredPolicy: 'Mandir.PaymentRequests',
    breadcrumbText: '::PaymentRequests',
  },
];
